<template>
  <div class="slm-event-list">
    <Results :result="upcoming"/>
    <Results :result="past"/>
  </div>
</template>

<script>
import Results from './components/Results.vue';

export default {
  name: 'App-template',
  computed: {
    upcoming() {
      return this.$store.state.upcoming;
    },
    past() {
        return this.$store.state.past;
    },
  },
  components: {
    Results,
  }
}
</script>
